import React from 'react'
import 'regenerator-runtime/runtime'
import Drafts from '../routes/Drafts'

const Routes = () => {
  return <Drafts />
}

export default Routes
